import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { LibraryModel } from '../models'

export interface MainPart extends LibraryModel {
    key: string
    new?: boolean
    updatedBy?: string
}
const url = `/libraries/management/types/mainPart/entries`

@Injectable()
export class MainPartService {
    constructor(private http: HttpService) {}

    getAll(): Observable<MainPart[]> {
        return this.http.get(url)
    }

    remove(data: MainPart[]): Observable<boolean> {
        return this.http.delete(url + '/', { data })
    }

    create(data: MainPart[]): Observable<unknown> {
        return this.http.post(url, { data })
    }
    update(data: MainPart[]): Observable<unknown> {
        return this.http.put(url, { data })
    }
}
